export default {
  LOAD_DOCUMENTS: 'AdditionalDocumentsConstants.LOAD_DOCUMENTS',
  SUBMIT_DOCUMENT: 'AdditionalDocumentsConstants.SUBMIT_DOCUMENT',
  FORM: 'AdditionalDocumentsConstants.FORM',
};
